import { put } from 'redux-saga/effects';

import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { newMessageEvent } from 'rdx/modules/messages/slice';

function* saveProcedureAsTemplate({ payload: { action, params } }) {
  const { success, error } = yield* makeRequest.action(action, params);
  if (success) {
    yield put(newMessageEvent({ text: 'Procedure Template Saved' }));
  } else if (error) {
    yield* putErrorActions({ error });
  }
  return null;
}

export default saveProcedureAsTemplate;
